export interface IComplianceInfo {
  complianceDocuments?: IComplianceDocuments;
  cacNumber: string;
}

export interface IComplianceDocuments {
  cacCertificate: string;
  psnCertificate: string;
}

export interface IComplianceUpdateDTO {
  complianceDocuments: IComplianceDocuments;
  cacNumber: string;
  pharmacyCode: string;
  pharmacyId: number;
}

export const defaultComplianceInfo: IComplianceUpdateDTO = {
  complianceDocuments: {
    cacCertificate: '',
    psnCertificate: '',
  },
  cacNumber: '',
  pharmacyCode: '',
  pharmacyId: 0,
};
